import type { Call as TelnyxCall } from '@telnyx/webrtc';
import type { CallState } from './types';

export class CallInfoParser {
  private static readonly FIELDS = [
    'sipStatus',
    'sipStatusText',
    'cause',
    'causeCode',
    'errorMessage',
    'callId',
    'connectionId',
    'sipErrorCode',
    'sipReason',
    'lastResponse',
  ] as const;

  private static readonly VALID_STATES: CallState[] = [
    'new',
    'requesting',
    'trying',
    'early',
    'ringing',
    'answered',
    'active',
    'hangup',
    'destroy',
  ];

  static isValidState(state: string): state is CallState {
    return this.VALID_STATES.includes(state as CallState);
  }

  static extract(call: TelnyxCall): Record<string, unknown> {
    const payload: Record<string, unknown> = {};
    const callAsRecord = call as unknown;
    this.FIELDS.forEach(field => {
      const value = (callAsRecord as Record<string, unknown>)[field];
      if (value !== undefined) payload[field] = value;
    });
    return payload;
  }

  static isMediaStream(stream: unknown): stream is MediaStream {
    return stream instanceof MediaStream;
  }

  static formatE164(phoneNumber: string): string {
    return phoneNumber.replace(/[^\d+]/g, '');
  }
}
